import useDeviceSize from "hooks/useDeviceSize";
import { ChakraBox as Box, ChakraText as Text, ChakraHeading as Heading } from "@airhelp/react-ui-components";
import type { CardDetailProps } from "./CardDetail.d";

export const CardDetail = ({ value, title }: CardDetailProps) => {
  const { isDesktop } = useDeviceSize();
  return (
    <Box>
      <Text color="greyscale.500" fontSize="sm" fontWeight="normal">
        {title}
      </Text>
      {isDesktop ? (
        <Heading variant="h5" as="h5">
          {value}
        </Heading>
      ) : (
        <Text fontSize={{ base: "md", md: "lg" }} fontWeight={{ base: "medium", md: "bold" }} color="primary.900">
          {value}
        </Text>
      )}
    </Box>
  );
};
